const state = {
    subscription: null,
    features: [],
    plans: [],
    selectedPlan: null,
}

const getters = {

    subscription: state => {
        return state.subscription;
    },

    features: state => {
        return state.features;
    },

    plans: state => {
        return state.plans;
    },

    selectedPlan: state => {
        return state.selectedPlan;
    },

}

const mutations = {

    setSubscription(state, subscription) {
        state.subscription = subscription;
    },

    setFeatures(state, features) {
        state.features = features;
    },

    setPlans(state, plans) {
        state.plans = plans;
    },

    setSelectedPlan(state, selectedPlan) {
        state.selectedPlan = selectedPlan;
    },

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
}